import { Form, Spin } from 'antd'
import Button from 'components/Button'
import Drawer from 'components/Drawer'
import Flex from 'components/Flex'
import ErrorMessage from 'components/UIComponents/MessagePopup/ErrorMessage'
import FileReader from 'components/Uploader/FileReader'
import CrossFillIcon from 'components/icons/CrossFillIcon'
import DownLoadIcon from 'components/icons/DownLoadIcon'
import UploadIcon from 'components/icons/UploadIcon'
import WarningIcon from 'components/icons/WarningIcon'
import {
  CandiadateFlex,
  CandidateInfo,
  Divider,
  DocFlex,
  ErrorWrap,
  FileNameDiv,
  FooterFlex,
  HeadTextWrap,
  ListItem,
  SpinStyle,
  StyledUpload,
  SubText,
  TemolateDiv,
  UploadFileDiv,
  UploadFlex,
  UploadIconDiv,
  Wrap,
} from 'modules/Drives/DownloadAndUpload/UploadResultDrawer/style'
import { uploadFile } from 'modules/ManageProfile/actions'
import { getNotificationCatalogues } from 'modules/Users/actions'
import React, { Fragment, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { handleScrollIntoView } from 'utils/ScrollToView'
import SuccessMessage from 'utils/SuccessMessage'
import { downloadAttachment } from 'utils/downloadAttachment'
import { permittedEventCruds } from 'utils/permissionsValidation'

import {
  bulkFileUploadStatus,
  getListOfCandidateListDownload,
} from 'modules/InterviewerDashboard/actions'
import { useParams } from 'react-router-dom'
import ConfirmDrawer from './ConfirmDrawer'

const UploadResult = ({
  uploadResult,
  setUploadResult,
  driveRoleList = [],
  selectedRoleId,
  setSelectedRoleId,
  upload,
  setUpload,
  rolesMetrics,
  setSearchParams,
  searchParams,
  currentSelection,
  getCandidateList,
}) => {
  const [form] = Form.useForm()
  const dispatch = useDispatch()
  const params = useParams()
  const [fileURL, setFileURL] = useState('')
  const [file, setFile] = useState('')
  const [errorMessage, setErrorMessage] = useState([])

  const [isFileLoader, setIsFileLoader] = useState(false)
  const [isLoader, setIsLoader] = useState(false)
  const permission = useSelector(state => state?.auth?.permissions)
  const [confirmDrawer, setConfirmDrawer] = useState(false)

  const [keysList, setKeysList] = useState([
    {
      key: '',
      qp: '',
    },
  ])
  const UserData = useSelector(state => state?.auth?.userData)
  const permittedEvents = permittedEventCruds(
    permission,
    'Evaluation Process - Fresher'
  )
  const Schedule =
    permittedEvents?.find(item => item.events?.eventName === 'VIEW')?.events ||
    ''

  const UserId = params?.userId ? params?.userId : UserData?._id
  useEffect(() => {
    ;(async () => {
      if (Schedule?.id) {
        await dispatch(getNotificationCatalogues(Schedule?.id))
      }
    })()

    return () => {}
  }, [Schedule])

  const resetForm = () => {
    form.resetFields()
    setSelectedRoleId(driveRoleList[0]?.roleId)

    setKeysList([
      {
        key: '',
        qp: '',
      },
    ])
    setFile('')
    setErrorMessage([])
    setFileURL('')
  }

  const handleUpload = async () => {
    setIsLoader(true)
    let payload = {
      file: true,
      interviewId: currentSelection?.interviewId,
      fileUrl: fileURL,
      roleId: currentSelection?.roleId,
    }

    let response = await dispatch(
      bulkFileUploadStatus({
        interviewId: currentSelection?.interviewId,
        interviewerID: UserId,
        payload: payload,
      })
    )
    if (response?.status >= 200 && response?.status <= 300) {
      SuccessMessage('File uploaded successfully!')
      if (getCandidateList) {
        getCandidateList()
      }
      setIsLoader(false)
      setUploadResult(false)
    } else {
      setIsLoader(false)
      handleScrollIntoView('error', 'center')
      setErrorMessage(response?.response?.data?.data?.failedRecords)
      if (getCandidateList) {
        getCandidateList()
      }
    }
  }

  const onDownload = async () => {
    let response = await dispatch(
      getListOfCandidateListDownload(
        UserId,
        currentSelection?.interviewRound,
        currentSelection?.roleId
      )
    )
    if (response.status >= 200 && response?.status <= 300) {
      downloadAttachment(response?.data?.data?.url)
      SuccessMessage('File downloaded successfully!')
    } else {
      ErrorMessage(response?.response?.data?.message)
    }
  }

  const dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess('OK')
    }, 0)
  }

  const onChangeFileUpload = async info => {
    setIsFileLoader(true)
    if (info?.file?.status === 'done') {
      setFile(info?.file)
      let response = await dispatch(
        uploadFile(info?.file?.originFileObj, info?.file?.name)
      )
      if (response) {
        setFileURL(response)
        setIsFileLoader(false)
        setErrorMessage([])
      }
    }
  }

  useEffect(() => {
    form.setFieldsValue({
      feedback: keysList,
    })
  }, [keysList])

  useEffect(() => {
    form.setFieldsValue({
      role: selectedRoleId,
    })
  }, [selectedRoleId])

  const content = () => {
    return (
      <>
        <br></br>
        <CandiadateFlex spaceBetween row centerVertically>
          <div style={{ display: 'flex', gap: '20px' }}>
            <DownLoadIcon />
            <DocFlex column>
              <CandidateInfo>Candidate Sample Doc</CandidateInfo>
              <TemolateDiv>
                To upload bulk upload data, use template
              </TemolateDiv>
            </DocFlex>
          </div>
          <Button.Secondary
            width="144px"
            height="32px"
            text="Download Sample"
            onClick={onDownload}
          />
        </CandiadateFlex>
        <Fragment>
          {isFileLoader && (
            <SpinStyle centerVertically center>
              <Spin />
            </SpinStyle>
          )}
          <StyledUpload
            multiple={false}
            type="file"
            accept={'.xlsx'}
            customRequest={dummyRequest}
            onChange={onChangeFileUpload}
            itemRender={(_, file) => {}}
          >
            <UploadFlex column alignCenter>
              <UploadIconDiv>
                <UploadIcon />
              </UploadIconDiv>
              <UploadFileDiv>Browse for file or Drag and drop</UploadFileDiv>
              <FileNameDiv>Formet (.xlsx)</FileNameDiv>
            </UploadFlex>
          </StyledUpload>
          {fileURL && (
            <FileReader
              file={file}
              setFile={setFile}
              fileURL={fileURL}
              setFileURL={setFileURL}
              setErrorMessage={setErrorMessage}
            />
          )}
        </Fragment>

        {errorMessage?.length > 0 && (
          <Fragment>
            <Divider />
            <HeadTextWrap>Summary</HeadTextWrap>
            <ErrorWrap>
              <CrossFillIcon />
              <SubText>Issue with the uploaded document</SubText>
            </ErrorWrap>
            <ErrorWrap id={'error'}>
              <Flex column>
                <Flex>
                  <WarningIcon />
                  <Wrap>
                    <SubText margin>Fix the following issues</SubText>
                  </Wrap>
                </Flex>

                {errorMessage?.map((data, index) => {
                  return (
                    <Wrap column key={index + data?.error + 'error'}>
                      <ListItem>
                        {data?.['First Name']} {data?.['Last Name']}{' '}
                        {data?.error}
                      </ListItem>
                    </Wrap>
                  )
                })}
              </Flex>
            </ErrorWrap>
          </Fragment>
        )}
      </>
    )
  }
  const footer = () => {
    return (
      <>
        {!upload && (
          <FooterFlex flexEnd>
            <Button.Secondary
              width="88px"
              text="Cancel"
              onClick={() => {
                resetForm()
                setUploadResult(false)
              }}
            />
            <Button.Primary
              width="90px"
              text="Upload"
              htmlType="submit"
              form={'uploadForm'}
              onClick={() => handleUpload()}
              disabled={!fileURL}
              loading={isLoader}
            />
          </FooterFlex>
        )}
      </>
    )
  }
  return (
    <>
      <Drawer
        width="43%"
        title={'Upload File'}
        placement="right"
        padding="0px 30px 30px 30px"
        visible={uploadResult}
        content={content()}
        footer={footer()}
        onClose={() => {
          resetForm()
          setUploadResult(false)
          setUpload(false)
        }}
        closable
      />
      <ConfirmDrawer
        confirmDrawer={confirmDrawer}
        setConfirmDrawer={setConfirmDrawer}
        file={''}
        rolesMetrics={rolesMetrics}
        setSearchParams={setSearchParams}
        searchParams={searchParams}
      />
    </>
  )
}

export default UploadResult
